import { extendTheme } from '@chakra-ui/react';
import { colors } from './colors';

const theme = {
  colors: colors,
};

export default extendTheme(theme);
